<template>
  <div>
    <el-row style="margin-top:10px">
      <el-col :span="6" :offset="6" style="text-align=center;font-size:17px">
        <span class="systemFont0">{{$t('p0216.currentPoints')}}</span>
        <span v-if="currentPoints" class="systemFont0">{{ this.currentPoints}}</span>
        <span v-if="!currentPoints" class="systemFont0">{{ "0"}}</span>
        <span class="systemFont0">{{ $t('p0216.points')}}</span>
      </el-col>
      <el-col :span="6" style="text-align=center;font-size:17px">
        <span class="systemFont0">{{$t('p0216.usedPoints')}}</span>
        <span v-if="usedPoints" class="systemFont0">{{ this.usedPoints}}</span>
        <span v-if="!usedPoints" class="systemFont0">{{ "0"}}</span>
        <span class="systemFont0">{{ $t('p0216.points')}}</span>
      </el-col>
    </el-row>
    <el-form
      ref="form"
      :model="userForm"
      label-width="60px"
      label-position="right"
      class="systemFont1"
    >
        <el-row style="top: 17px">
          <el-col :span="22" :offset="1">
            <div class="mar">
              <el-form-item :label="$t('p0216.selectTime')">
                <el-select v-model="userForm.year" @change="initSelectYear()" :placeholder="$t('p0216.pleaseSelect')" style="width:100px;" >
                  <el-option
                    v-for="item in yearsOpList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="userForm.month" @change="initSelectMonth()" :placeholder="$t('p0216.pleaseSelect')" style="width:100px;" >
                  <el-option
                    v-for="item in monthsOpList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="submit" style="margin-left: 10px;"
                @click.native.prevent="submit()">{{$t('p0216.select')}}</el-button>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
        <el-row style="margin-top:5px">
          <el-col :span="24">
            <el-table style="width:100%" :data="pointData">
              <!-- 时间 -->
              <el-table-column
                :label="$t('p0216.selectTime')"
                prop="time"
                align="center"
                min-width="110px"
              ></el-table-column>
              <!-- 应用 -->
              <el-table-column
                :label="$t('p0216.apply')"
                prop="apply"
                align="center"
                min-width="125px"
              >
              </el-table-column>
              <!-- 操作 -->
              <el-table-column
                :label="$t('p0216.operation')"
                prop="operation"
                align="left"
                min-width="230px"
              ></el-table-column>
              <!-- 积分-->
              <el-table-column
                :label="$t('p0216.selectPoints')"
                prop="points"
                align="center"
                :formatter="pointsFormat"
                min-width="100px"
              ></el-table-column>
            </el-table>
            <!-- 返回 -->
            <el-button
              style="margin-top:55px"
              type="return"
              @click="goBack()"
              >{{ $t("common.back") }}</el-button
            >
          </el-col>
        </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "TQSManagementP0216",

  data() {
    let p0212 = JSON.parse(sessionStorage.getItem("p0212"));
    return {
      p0212: p0212,
      pointData: [],
      currentPoints:"",
      usedPoints: "",
      userForm:{
        year:new Date().getFullYear(),
        month:new Date().getMonth() + 1,
      },
      yearsOpList:[],
      monthsOpList:[],
      currentPage: JSON.parse(sessionStorage.getItem("p0212")).currentPage,
    };
  },

  mounted() {
    // this.init();
    // this.submit();
  },

  methods: {
    // 初始化
    init() {
      this.initSelectYear(this.userForm.year)
      this.initSelectMonth();
      var date = new Date(this.userForm.year, this.userForm.month - 1, 1);
      var startTime = this.getMonthFrist(date);
      var endTime = this.getMonthLast(date);
      // console.log("startTime:",startTime)
      // console.log("endTime", endTime)
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/basicInformation/pointsStatistic";
      this.$http
        .post(url, {
          userID: this.p0212.userID,
          startTime: startTime,
          endTime: endTime
        })
        .then(response => {
          if (response.data.code === 200) {
            this.currentPoints = response.data.data.currentPoints;
            this.usedPoints = response.data.data.usedPoints;
            this.pointData = response.data.data.pointDataList;
            loading.close();
          } else {
            this.currentPoints = null;
            this.usedPoints = null;
            this.pointData = null;
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 年份下拉框
    initSelectYear(year){
      this.years = [];
       var myDate = new Date()
      var startYear = myDate.getFullYear() - 50// 起始年份
      var endYear = myDate.getFullYear() + 50// 结束年份

      this.yearsOpList = []
      for (var i = startYear; i <= endYear; i++) {
        this.yearsOpList.push({value: (i), label: (i)})
      }
      // for(let i=0;i<30;i++){
      // this.years.push({value:(year - i),label:(year - i)+ "年"});
      // }
    },
    // 月份下拉框
    initSelectMonth(){
      this.monthsOpList = [];
        for(let i=1;i<=12;i++){
        this.monthsOpList.push({value:i,label:i+ "月"});
      }
    },
    // 查询
    submit(){
        this.init();
    },
    // 日期格式化
    timeFormat(row) {
      return moment(row.dateAndTime).format("YYYY-MM-DD");
    },
    // 积分格式化
    pointsFormat(row) {
      if (row.increaseDecrease == "0") {
        return "+" + row.points;
      } else {
        return "-" + row.points;
      }
    },
    // 返回按钮
    goBack() {
      //返回按钮标示
      sessionStorage.setItem("detail", true);
      sessionStorage.setItem("currentPage", this.currentPage);
      //返回按钮标示
      this.$router.go(-1);
    },
    getMonthFrist(timestamp) {
      let date = timestamp ? new Date(timestamp) : new Date()
      let year = date.getFullYear()
      let month = date.getMonth()
      return new Date(year, month, 1)
    },
    getMonthLast(timestamp) {
      let date = timestamp ? new Date(timestamp) : new Date()
      let year = date.getFullYear()
      let month = date.getMonth()
      // day为0表示获取上一个月最后一天，所以month+1  
      // 86300表示一天秒数，最后日期为 23:59:59
      return new Date(year, month + 1, 0)
    }
  }
};
</script>

<style lang="scss" scoped>
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
  padding: 8.5px 0;
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .mar {
  text-align: left;
}
>>>.el-input__inner{
  height: 32px
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0216.vue